import BitrixCompanyDto from "../../dto/Dictionaries/BitrixCompanyDto";
import { ContractorBasicInfoDto } from "../../dto/Contractors/ContractorBasicInfoDto";
import ContractorDto from "../../dto/Settings/ContractorDto";

// Keep the existing counterparty controls' read model; IDs remain local and use only /contractors APIs.
export class LocalCompanyDataConverter {
  static fromNameInfo(contractor: ContractorDto): BitrixCompanyDto {
    return { id: contractor.id, name: contractor.name, isBlackList: contractor.isBlackList, address: [] };
  }

  static fromBasicInfo(contractor: ContractorBasicInfoDto): BitrixCompanyDto {
    const requisites = contractor.requisites;
    return {
      id: contractor.id,
      name: contractor.name,
      type: contractor.type,
      country: contractor.country,
      isBlackList: contractor.isBlackList ?? false,
      requisites: requisites ? [{ ...requisites, template: requisites.template === "CH" ? "OTHER" : requisites.template }] : [],
      address: contractor.address
        ? [
            {
              address: [
                contractor.address.postalCode,
                contractor.address.region,
                contractor.address.province,
                contractor.address.city,
                contractor.address.address,
              ]
                .filter(Boolean)
                .join(", "),
            },
          ]
        : [],
      contracts: contractor.contracts ?? [],
      carrierComment: contractor.carrierComment,
      contractTerms: contractor.contractTerms,
      paymentType: contractor.paymentType,
    };
  }
}
